/* eslint-disable lingui/text-restrictions */
/* eslint-disable lingui/no-unlocalized-strings */

import { CircleNotch } from "@phosphor-icons/react";
import { isBillingInterval, isPlanTier } from "@reactive-resume/utils";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { toast } from "@/client/hooks/use-toast";
import { trackTikTokInitiateCheckout } from "@/client/libs/analytics";
import { axios } from "@/client/libs/axios";
import { useAuthStore } from "@/client/stores/auth";

export const CheckoutPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const user = useAuthStore((s) => s.user);
  const initiated = useRef(false);

  useEffect(() => {
    if (initiated.current) return;
    initiated.current = true;

    const tier = searchParams.get("plan");
    const intervalParam = searchParams.get("interval");
    const interval = isBillingInterval(intervalParam) ? intervalParam : "monthly";

    if (!isPlanTier(tier)) {
      navigate("/dashboard/resumes", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post<{ url: string; sessionId: string }>("/billing/checkout", {
          tier,
          interval,
          sourceUrl: window.location.href,
        });
        if (data.sessionId) {
          await trackTikTokInitiateCheckout({
            tier,
            interval,
            eventId: data.sessionId,
            userId: user?.id ?? null,
            email: user?.email,
          });
        }
        if (data.url) {
          window.location.href = data.url;
          return;
        }
      } catch {
        toast({
          variant: "error",
          title: "Could not start checkout",
          description: "Please try again from the pricing page.",
        });
      }
      navigate("/dashboard/resumes", { replace: true });
    })();
  }, [searchParams, navigate]);

  return (
    <div className="flex h-[60vh] flex-col items-center justify-center gap-4">
      <CircleNotch size={32} className="animate-spin text-primary" />
      <p className="text-sm text-foreground/60">Redirecting to checkout...</p>
    </div>
  );
};
